import type { ReactNode } from 'react'
import InfoTip from './InfoTip'

// Title row for a list/table page: page title (+ optional info tooltip) on the
// left, an optional action (e.g. "+ Neuer Kunde") on the right. The search /
// filter controls live inside the table block — see ListPanel.
interface Props {
    title: string
    infoText?: string
    action?: ReactNode
}

export default function ListToolbar({ title, infoText, action }: Props) {
    return (
        <div className="row" style={{ marginBottom: 18 }}>
            <div className="page-title">
                <h1>{title}</h1>
                {infoText && <InfoTip>{infoText}</InfoTip>}
            </div>
            {action}
        </div>
    )
}
